import React, { useState } from "react";
import { format } from "date-fns";
import strings from "../../helpers/Localization";
import ButtonSKA from "../Buttons/ButtonSKA";
import Modal from "../Modal/Modal";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(customParseFormat);
import IconComponent from "../Icons/IconComponent";
import GraphBarComposed from "../Graph/GraphBarComposed";
import Pill from "../Pill/Pill";
import RatingPilot from "../Rating/RatingPilot";

const CardReporting = ({ minHeight, background, textTooltip, flex, resultType, textPill, resultReport, infosReport, textPill2, resultReport2, infosReport2, rightButtonIcon, onRightButtonClick, rightButtonIcon2, onRightButtonClick2, infosReportTopRight, infosReportTopRight2 }) => {
    const [indexButtonClicked, setIndexButtonClicked] = useState(0);
    const [DialogEventsSelector, setDialogEventsSelector] = useState(false);

    const fills = indexButtonClicked === 0 ?
        ["var(--graph1)", "var(--graph2)", "var(--graph3)", "var(--graph1)", "var(--graph2)", "var(--graph3)"] :
        ["var(--redgraph1)", "var(--redgraph2)", "var(--redgraph3)", "var(--redgraph1)", "var(--redgraph2)", "var(--redgraph3)"];

    const CardGraph = () => {
        const data = indexButtonClicked === 0 ? resultReport : resultReport2;
        return (
            <GraphBarComposed
                data={data}
                labelTooltip={textTooltip ? textTooltip : strings.calls}
                fills={fills}
            />
        );
    };

    const CardNotation = () => {
        return <>
            {!infosReport ? <span style={{ height: "5px" }}></span> : null}
            <div className="result-report" style={{ gap: "0px" }}>
                {resultReport.map((review, index) => {
                    return <React.Fragment key={index}>
                        <div className={"bloc-rating"} key={index} style={{
                            padding: "0px", borderRadius: "0px", width: "100%",
                            color: review.isHighest ? "var(--primary-base)" : review.quantity < 1 ? "var(--grey-light)" : "default"
                        }}>
                            { !review.note ? <span>{strings.noRating}</span> : <RatingPilot
                                starsColored={review.note}
                                isHighest={review.isHighest}
                            />}
                            <p className="quantity-rating">{review.quantity}</p>
                        </div>
                        {
                            index !== resultReport.length - 1 ?
                                <span style={{ width: "100%", borderBottom: "1px solid var(--grey-light)", backgroundColor: "var(--grey-light)" }}></span>
                                :
                                null
                        }
                    </React.Fragment>;
                })}
            </div>
            {! infosReport ? <span style={{ height: "5px" }}></span> : <div className="infos-report"> { infosReport } </div>}
        </>;
    };

    const CardNumber = () => {
        return <>
            <div className="result-report"><span>{ indexButtonClicked === 0 ? resultReport : resultReport2 }</span></div>
            {
                <div className="infos-report">
                    { indexButtonClicked === 0 && infosReport ? infosReport :
                        infosReport2 ? infosReport2 : null }
                </div>
            }
        </>;
    };

    const CardEventDates = () => {
        const array = [];
        const spliceArray = [];
        const rr = resultReport.sort((a, b) => b.dateStart.localeCompare(a.dateStart));
        for (let i = 0; i < rr.length; i++) {
            const dateStart = new Date(rr[i].dateStart);
            const dateEnd = new Date(rr[i].dateEnd);
            const diff = Math.floor((dateEnd - dateStart) / 1000);
            const hours = Math.floor(diff / 3600);
            const minutes = Math.floor(diff % 3600 / 60);
            const secs = diff % 60;
            const paddedHours = String(hours).padStart(2, "0");
            const paddedMinutes = String(minutes).padStart(2, "0");
            const paddedSeconds = String(secs).padStart(2, "0");

            const sdiff = paddedHours > 0 ? `${paddedHours}:${paddedMinutes}:${paddedSeconds}` : `${paddedMinutes}:${paddedSeconds}`;
            const obj = {
                day: format(dateStart, "dd.MM.yyyy"),
                start: format(dateStart, "HH:mm"),
                end: format(dateEnd, "HH:mm"),
                duration: sdiff
            };
            array.push(obj);
            if (rr.length < 7 || i < 5) {spliceArray.push(obj);}
        }

        return <>
            <div className="result-report" style={{ height: rr.length > 7 ? "260px" : "275px" }}>
                {spliceArray.map((element, index) => {
                    return <div className={"bloc-rating"} key={index}>
                        <p style={{ fontWeight: "700" }}>{element.day}</p>
                        <p>{"Durée · " + element.duration}</p>
                        <p>{"Début · " + element.start}</p>
                        <p>{"Fin · " + element.end}</p>
                    </div>;
                })}
                {
                    rr.length >= 7 ? <div className="infos-report" style={{ margin: "-5px 0px 0px 0px" }}>
                        <ButtonSKA
                            type="primary-icon"
                            onClick={() => setDialogEventsSelector(true)}
                            nameIcon="add"
                            text={"Voir tout"}
                        />
                    </div> : <div className="infos-report"></div>
                }
            </div>

            <Modal open={DialogEventsSelector}
                onClose={() => setDialogEventsSelector(false)}
                title={"Liste des évènements"}
            >
                {array.map((element, index) => {
                    return <div className={"bloc-rating"} key={index}>
                        <p style={{ fontWeight: "700" }}>{element.day}</p>
                        <p>{"Durée · " + element.duration}</p>
                        <p>{"Début · " + element.start}</p>
                        <p>{"Fin · " + element.end}</p>
                    </div>;
                })}
            </Modal>

        </>;
    };

    const CardPopularQuesries = () => {

        const data = indexButtonClicked === 0 ? resultReport : resultReport2;
        const sortedResultReport = data.sort((a, b) => b.count - a.count);

        return (
            <>
                <div className="result-report">
                    {["#1", "#2", "#3", "#4", "#5"].map((number, index) => {
                        return (
                            <div className={"bloc-rating"} key={index} style={{ justifyContent: "flex-start",
                                padding: "0px", borderRadius: "0px", height: "44px",
                                borderBottom: index < 4 ? "1px solid var(--grey-light)" : null
                            }}>
                                <p style={{ margin: "14px 10px 14px 0px" }}>{number + " "}</p>
                                <p>{sortedResultReport.length > index ? sortedResultReport[index].name : ""}</p>
                                <span style={{ flexGrow: "1" }}></span>
                                <p>{sortedResultReport.length > index ? sortedResultReport[index].count + " " + strings.call + (sortedResultReport[index].count > 1 ? "s" : "") : ""}</p>
                            </div>
                        );
                    })}
                </div>
            </>
        );
    };

    const CardDisponibilityList = () => {
        const data = indexButtonClicked === 0 ? resultReport : resultReport2;

        return (
            <div style={{ maxHeight: "300px", overflowY: "auto", paddingRight: "15px" }}>

                {data.map((line, index) => {

                    let subtitle = null;
                    if ( data.filter(o => o.name === line.name).length > 1) {
                        subtitle = line.subtitle;
                    }
                    const percent = line.count > 0 ? Math.round(line.count2 * 100 / line.count) : 0;
                    const minutes = Math.trunc(line.count2 / 60);
                    const hours = Math.trunc(minutes / 60);

                    return <div className={"bloc-rating"} key={line.name + "-" + index}
                        style={{ display: "flex", flexDirection: "row", gap: "8px", width: "auto",
                            padding: "0px", borderRadius: "0px",
                            borderBottom: index < data.length - 1 ? "1px solid var(--grey-light)" : null
                        }}>
                        <p>{line.name}</p>
                        {subtitle ? <p>{"- " + subtitle}</p> : null}
                        <span style={{ display: "flex", flexGrow: "1" }}/>
                        <p style={{ color: percent <= 50 ? "#FF002E" : "#00C45B" }}>{percent + "%"}</p>
                        <p>·</p>
                        <p>{(hours > 0 ? hours + " h " : "") + (minutes - hours * 60) + " min"}</p>
                    </div>;
                })}

            </div>
        );
    };

    const getResult = () => {
        switch (resultType) {
            case "number" : return CardNumber();
            case "notation" : return CardNotation();
            case "graph" : return CardGraph();
            case "eventsdates" : return CardEventDates();
            case "popularQueries" : return CardPopularQuesries();
            case "disponibilitylist" : return CardDisponibilityList();
            default : return null;
        }
    };

    return (
        <div className='container-card-reporting' style={{ flex: flex, position: "relative", backgroundColor: background ? "#F7F7F7" : null, minHeight: minHeight ? minHeight : null }}>
            <div className="horizontalFlexContainer" style={{ height: "36px", gap: "10px", alignItems: "flex-start", width: "calc(100%)" }}>
                <Pill
                    type={indexButtonClicked === 1 ? "default" : "current"}
                    onClick={textPill2 ? () => setIndexButtonClicked(0) : null}
                    text={textPill}
                />
                {
                    textPill2 ?
                        <Pill
                            type={indexButtonClicked === 0 ? "default" : "current"}
                            onClick={() => setIndexButtonClicked(1)}
                            text={textPill2}
                        />
                        :
                        null
                }
                <span style={{ flexGrow: 1 }}/>
                {
                    indexButtonClicked === 0 && infosReportTopRight ? <div className="infos-report" style={{ margin: "0px", padding: "0px" }}>{infosReportTopRight}</div> : null
                }
                {
                    indexButtonClicked === 1 && infosReportTopRight2 ? <div className="infos-report" style={{ margin: "0px", padding: "0px" }}>{infosReportTopRight2}</div> : null
                }
                {
                    indexButtonClicked === 0 && onRightButtonClick ? <div style={{ }}>
                        <ButtonSKA
                            type="round-secondary"
                            onClick={() => onRightButtonClick()}
                            nameIcon={rightButtonIcon}
                        /></div> : null}
                {
                    indexButtonClicked === 1 && onRightButtonClick2 ? <div style={{}}>
                        <ButtonSKA
                            type="round-secondary"
                            onClick={() => onRightButtonClick2()}
                            nameIcon={rightButtonIcon2}
                        /></div> : null}
            </div>
            {getResult()}
        </div>
    );
};

export default CardReporting;
